import gql from 'graphql-tag'

export default gql`
mutation exportAllRunnerAnywhereCount($types : String){
    exportAllRunnerAnywhereCount(types : $types){
    url
    fileName
  }
}
`